<template>
	<div class="popuptos" v-if="isshow">
		<div class="popubox">
			<div class="poputitle">提示</div>
			<div class="poputext">
				{{text}}
			</div>
			<div class="btna">
				<a href="javascript:void(0);" @click="popuptoshide">确定</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'popuptos',
		data(){
			return{
				isshow:false
			}
		},
		props:{
			text: String
		},
		methods:{
			popuptosshow(){
				this.isshow = true
			},
			popuptoshide(){
				this.isshow = false
			}
		}
	}
</script>

<style>
	.popuptos{
		background: rgba(0,0,0,0.5);
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		z-index: 99;
	}
	.popuptos .popubox{
		position: absolute;
		width: 25rem;
		height: 19.5rem;
		background: #FFFFFF;
		margin: auto;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		border: 3px solid rgba(197,141,68,1);
	}
	.popuptos .poputitle{
		margin: 1px;
		height: 4rem;
		background: url(../../assets/images/tsbag.png) no-repeat 100%;
		color: #FFFFFF;
		font-size: 2rem;
		text-align: center;
		line-height: 4rem;
		font-family: 'STXingkai';
	}
	.popuptos .poputext{
		height: 7.5rem;
		text-align: center;
		padding: 2rem;
	}
	.popuptos .btna a{
		display: block;
		width: 8rem;
		height: 3rem;
		background: #a73a29;
		color: #FFFFFF;
		text-align: center;
		line-height: 3rem;
		font-size: 1.2rem;
		margin: 0px auto;
		text-decoration: none;
	}
	.popuptos .poputext{
		font-size: 1.2rem;
		color: #823d32;
		overflow: hidden;
	}
</style>
